import React, { useState } from "react";

const Calendar = ({
  handleDateChange,
  highlightDatesWithEvents,
  selectedDate,
  onMonthChange,
  handleDateHover, // New prop for hover
  handleDateLeave  // New prop for mouse leave
}) => {
  const [currentDate, setCurrentDate] = useState(new Date(selectedDate));

  const handlePrevMonth = () => {
    const prevMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    setCurrentDate(prevMonth);
    onMonthChange(prevMonth);
  };

  const handleNextMonth = () => {
    const nextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
    setCurrentDate(nextMonth);
    onMonthChange(nextMonth);
  };

  const generateCalendarDays = () => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const firstDayOfMonth = new Date(year, month, 1);
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const firstDayOfWeek = firstDayOfMonth.getDay();
    const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    const monthDays = [];

    // Days of the week header
    daysOfWeek.forEach((day, index) => {
      monthDays.push(
        <div key={`dow-${index}`} className="text-center font-semibold text-gray-600 text-xs sm:text-base">
          {day}
        </div>
      );
    });

    // Empty spaces before first day
    for (let i = 0; i < firstDayOfWeek; i++) {
      monthDays.push(<div key={`empty-${i}`}></div>);
    }

    // Days of month
    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month, day);
      const isToday = date.toDateString() === new Date().toDateString();
      const isSelected = date.toDateString() === selectedDate.toDateString();
      const isEventDay = highlightDatesWithEvents(date);

      monthDays.push(
        <div
          key={day}
          className={`text-center py-2 border cursor-pointer rounded-lg transition duration-300 ease-in-out
            hover:bg-gray-200 hover:text-black
            ${isEventDay ? "bg-blue-800 text-white" : ""}
            ${isToday ? "bg-green-500 text-white" : ""}
            ${isSelected ? "bg-gray-300" : ""}`}
          onClick={() => handleDateChange(day)}
          onMouseEnter={() => handleDateHover && handleDateHover(date)} // Hover event
          onMouseLeave={() => handleDateLeave && handleDateLeave()}     // Leave event
        >
          {day}
        </div>
      );
    }

    return monthDays;
  };

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const currentMonthName = monthNames[currentDate.getMonth()];
  const currentYear = currentDate.getFullYear();

  return (
    <div className="bg-white p-2 sm:p-4 rounded-lg shadow-md w-full max-w-sm sm:max-w-md mx-auto relative">
      <div className="flex items-center justify-between mb-2 sm:mb-4">
        <button
          onClick={handlePrevMonth}
          className="px-2 py-1 sm:px-3 sm:py-1 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition duration-300 flex items-center"
        >
          <i className="fas fa-chevron-left mr-1"></i>
          <span className="hidden sm:inline">Previous</span>
        </button>
        <div className="text-base sm:text-lg font-semibold">
          {currentMonthName} {currentYear}
        </div>
        <button
          onClick={handleNextMonth}
          className="px-2 py-1 sm:px-3 sm:py-1 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition duration-300 flex items-center"
        >
          <span className="hidden sm:inline">Next</span>
          <i className="fas fa-chevron-right ml-1"></i>
        </button>
      </div>
      <div className="grid grid-cols-7 gap-1 sm:gap-2">
        {generateCalendarDays()}
      </div>
    </div>
  );
};

export default Calendar;
